import { inject, Injectable } from '@angular/core'
import { AppDownloadService } from '@ftr/api-core'
import { Observable, of } from 'rxjs'
import { getAccessNavItemsGroup } from '../access-nav-items'
import { REQUEST_NAV_ITEMS_GROUP } from '../request-nav-items'
import { getPublicHelpSupportNavItem, SideNavGroup, SideNavItem } from '../side-nav-item'

@Injectable({
  providedIn: 'root',
})
export class PublicNavItemsProvider {
  private readonly appDownloadService = inject(AppDownloadService)

  provide(): Observable<{ navGroups: SideNavGroup[]; footerItems: SideNavItem[] }> {
    return of({
      navGroups: [REQUEST_NAV_ITEMS_GROUP, getAccessNavItemsGroup()],
      footerItems: [getPublicHelpSupportNavItem(this.appDownloadService.getStandaloneAppLink())],
    })
  }
}
